import { StageBugReport } from "./dbModels"
import { getUserDataById } from "./requestsUtils/functionsRequests/user/userFunctions"

const allStages: StageBugReport[] = ["dev", "stage", "prod"]

// id -> stage where the user exists (the users of a bug report can be of the stage of whoever did the action, not of the bug report)
const stageByUserId = new Map<string, StageBugReport>()
const pending = new Map<string, Promise<StageBugReport | undefined>>()

// Looks for the user in the preferred stage first and then in the others, undefined if it is not in any
export const resolveUserStage = (userId: string, preferred?: StageBugReport): Promise<StageBugReport | undefined> => {
    const cached = stageByUserId.get(userId)
    if(cached)
        return Promise.resolve(cached)

    const key = `${preferred ?? ""}:${userId}`
    const inProgress = pending.get(key)
    if(inProgress)
        return inProgress

    const order = preferred ? [preferred, ...allStages.filter((s) => s !== preferred)] : allStages

    const search = (async () => {
        for(const stage of order){
            try {
                await getUserDataById(userId, { firstName: 1 }, stage)
                stageByUserId.set(userId, stage)
                return stage
            } catch (error) {
                // 404: the user is not in this stage
            }
        }
        return undefined
    })().finally(() => { pending.delete(key) })

    pending.set(key, search)
    return search
}
